import AdminViewModel from 'admin/AdminViewModel'
import * as React from 'react'
import { observer } from 'mobx-react'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import NavItem from '../../../iam/components/NavItem'
import link from 'infra/link'
import { SplitViewHeader, SplitViewHeaderTitle } from 'components/SplitView'
import ScrollView from 'components/ScrollView'

interface AdminNavProps {
  vm: AdminViewModel
}

export default observer(function AdminNav({ vm }: AdminNavProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)

  return (
    <Sandwich stretch>
      <SandwichBun>
        <SplitViewHeader compact scrollOffset={scrollOffset}>
          <SplitViewHeaderTitle>Admin</SplitViewHeaderTitle>
        </SplitViewHeader>
      </SandwichBun>
      <SandwichContent>
        <ScrollView ref={scrollRef}>
          {vm.canManageJobScopeChangeRequest && (
            <NavItem
              to={link.adminChangeRequests()}
              title={`Change requests (${vm.scopeChangeRequestsCount})`}
            >
              Approve or reject job updates
            </NavItem>
          )}

          {vm.canManageBookkeeping && (
            <NavItem
              to={link.adminBookkeepingManager()}
              title={`Bookkeeping manager (${vm.bookkeepingManagerVM?.searcher.total})`}
            >
              Manage bookkeeping access & assesments
            </NavItem>
          )}
          {vm.canSeeStaffingManager && (
            <NavItem to={link.adminStaffingManager()} title="Staffing manager">
              Manage and post workspace opportunities
            </NavItem>
          )}
          {vm.canManageServices && (
            <NavItem to={link.adminBundleManager()} title="Bundle manager">
              Package service items as bundles
            </NavItem>
          )}
          {vm.canManageServices && (
            <NavItem to={link.adminServiceManager()} title="Service manager">
              Manage work items related to the platform
            </NavItem>
          )}
          {vm.isPlatformAdmin && vm.payoutsAdminVm && (
            <NavItem to={link.adminPayouts()} title="Payouts">
              Review the next payouts and view past ones
            </NavItem>
          )}
          {vm.canManageAccountMergeRequests && (
            <NavItem
              to={link.adminAccountMergeRequests()}
              title="Merge requests"
            >
              Review account merge requests
            </NavItem>
          )}
        </ScrollView>
      </SandwichContent>
    </Sandwich>
  )
})
